<template>
    <div id="calendarFilter">
        <v-select dir="rtl" v-model="projectId" @search="onSearchProject" label="fullTitle" placeholder="پروژه" @option:selected="selectProject" :options="ProjectList" :reduce="p => p.projectId">
            <template v-slot="option">
                <div class="d-center">
                    {{ option.fullTitle }}
                </div>
            </template>
        </v-select>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                projectFilterText: "",
                projectId: null
            }
        },
        watch: {
            'projectId'(value) {
                if (!value) {
                    this.projectId = null;
                    this.$emit('selectProject', this.projectId);
                }
            }
        },
        computed: {
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
        },
        methods: {
            onSearchProject(search) {
                if (search.length >= 2) {
                    this.projectFilterText = search;
                    this.GetProjectList();
                }
                if (search == null || search == '') {
                    this.projectFilterText = "";
                    this.GetProjectList();
                }
            },
            selectProject(d) {
                this.projectId = d.projectId;
                this.$emit('selectProject', this.projectId);
            },
            GetProjectList() {
                this.$store.dispatch("GetProjectListFromServer", {
                    text: this.projectFilterText,
                });
            }
        },
        created() {
            this.GetProjectList();
        }
    }
</script>
